import PropTypes from 'prop-types';
import React from 'react';
import { FormAPI } from 'lecom-api';

import InputGroup from 'form/components/form/input_group.jsx';
import Input from 'form/components/input/input';
import FormFieldTypes from 'form/constants/form_field_types';
import { formatDatetime, formatToNumber } from 'utils/formatting_utils';
import DocumentStoreItem from '../../models/document_store_item';
import { DocumentActions } from '../../reflux/document_store';

export default class DocumentMetadataFieldsInputGroup extends React.Component {

	static propTypes = {
		id: PropTypes.string,
		containerId: PropTypes.string,
		name: PropTypes.string,
		store: PropTypes.object,
		editMode: PropTypes.bool,
		onChange: PropTypes.func
	};

	static defaultProps = {
		id: '',
		containerId: '',
		name: '',
		store: new DocumentStoreItem(),
		editMode: false,
		onChange: () => {}
	};

	constructor(props) {
		super(props);
		this.handleMetadataFieldChange = this.handleMetadataFieldChange.bind(this);
	}

	get template() {
		return this.props.store.template;
	}

	get document() {
		return this.props.store.document;
	}

	get metadataValidationErrors() {
		return this.props.store.metadataValidationErrors;
	}

	buildMetadataFieldId(fieldKey) {
		return `${fieldKey}_${this.props.containerId}_templateField`;
	}

	parseMetadataFields() {
		var metafields = { };
		Object
			.keys(this.template.fields)
			.forEach(key => {
				metafields[key] = this.parseMetadataField(key);
			});

		return metafields;
	}

	getRequiredValidations (validations) {
		for (let cont = 0, len = validations.length; cont < len; cont++) {
			if (validations[cont].hasOwnProperty("required") && validations[cont].required) {
				return true;
			}
		}

		return false;
	}

	parseMetadataField(fieldKey) {
		const metadataField = Object.assign({}, this.template.fields[fieldKey]);
		metadataField.id = this.buildMetadataFieldId(fieldKey);
		metadataField.className += metadataField.type === 'AUTOCOMPLETE' ? ' field-autocomplete-modal' : '';
		metadataField.className += this.props.isMobile ? ' field-mobile' : '';
		metadataField.onChange = this.handleMetadataFieldChange.bind(this, fieldKey);
		metadataField.required = this.getRequiredValidations(metadataField.validations);

		setTimeout(() => {
			if(metadataField.type === 'NUMBER'){
				document.getElementById(metadataField.id).maxLength = 15;
			}
		}, 200)

		if (this.props.isMobile && metadataField.component === 'autocomplete') {
			metadataField.component = 'select';
		}

		return metadataField;
	}

	handleMetadataFieldChange(fieldKey, event, fieldValue) {
		var dataFieldValue = Array.isArray(fieldValue) ? fieldValue[0] : fieldValue;
		const { type } = this.template.fields[fieldKey];

		if (type === FormFieldTypes.CURRENCY)
			dataFieldValue = formatToNumber(dataFieldValue);
		if(type === FormFieldTypes.DATE)
			dataFieldValue = formatDatetime(dataFieldValue);
		if(type === FormFieldTypes.NUMBER && dataFieldValue !== null && dataFieldValue !== undefined)
			dataFieldValue = dataFieldValue.replace(/[^-+\d]/g, '');

		DocumentActions.setSubmitMetadataField(this.props.id, this.props.containerId, fieldKey, dataFieldValue);

		return false;
	}

	ensureMetadataSynchronization(fieldValues) {
		const { store } = this.props

		let metafieldValues = {}
		const associatedFields = store.inputProps.formFieldMappings

		Object.keys(fieldValues).forEach((key) => {
			const associatedField = associatedFields.find((field) => {
				return field.documentField === key
			})

			if (associatedField !== undefined) {
				const { inputProps } = this.props.store

				const formApi = FormAPI.form(inputProps.formId)
				const formFieldValue = formApi.fields(associatedField.formField.id).value()

				setTimeout(() => {
					store.submitData.CHECKIN.metadata.forEach((metadataField) => {
						if (metadataField.id === key) {
							metadataField.value = formFieldValue
						}
					})
				}, 0)

				metafieldValues[this.buildMetadataFieldId(key)] = formFieldValue
			} else {
				metafieldValues[this.buildMetadataFieldId(key)] = fieldValues[key]
			}
		})

		return metafieldValues
	}

	parseMetadataFieldValues() {
		const { fieldValues } = this.document
		const { editMode, store } = this.props

		const isEnsureMetadataSynchronization = editMode && store.inputProps.syncMetadata

		if (isEnsureMetadataSynchronization) {
			return this.ensureMetadataSynchronization(fieldValues)
		}

		let metafieldValues = {}

		Object.keys(fieldValues).forEach((key) => {
			metafieldValues[this.buildMetadataFieldId(key)] = fieldValues[key]
		})

		return metafieldValues
	}

	render() {
		const metadataFieldValues = this.parseMetadataFieldValues();
		const metadataFields = this.parseMetadataFields();

		return (
			<InputGroup
				inputWrapperComponent={Input}
				inputs={metadataFields}
				data={metadataFieldValues}
				errors={this.metadataValidationErrors}
				disabled={this.props.readOnly}
				readOnly={this.props.readOnly}
				metadataFieldsToDisable={this.props.metadataFieldsToDisable}
			/>
		);
	}
}
